import { useGetData, useToggleStatusMutation } from "@/services";
import { MasterModuleLayout, useMasterModule } from "../Common";

const InsuranceType = () => {
  const masterHook = useMasterModule({
    queryKey: "insurance-types",
    idKey: "insuranceTypeId",
    nameKey: "insuranceType",
    useGetDataQuery: useGetData,
    useToggleStatusMutation: useToggleStatusMutation,
    module: "insurance-types",
    statusSuccessMessage: "Insurance Type Status Updated Successfully",
  });

  return <MasterModuleLayout title="Insurance Types" hookResult={masterHook} />;
};

export default InsuranceType;
